{
  "apply": "Aplicar",
  "buttonLabel": "Filtros",
  "close": "Cerrar",
  "deleteSelectedFilter": "Eliminar el filtro seleccionado",
  "header": "Filtros",
  "searchByName": "Búsqueda por nombre",
  "model": "Gama",
  "type": "Tipo",
  "clearFilters": "Eliminar los filtros",
  "connectivity": "Conectividad",
  "certificate": "Certificado",
  "state": "Estado",
  "certificateValidity": {
    "title": "Validez del certificado",
    "expired": "Caducado",
    "validityUnder1": "Válido < 1 mes",
    "validityUnder3": "Válido < 3 meses",
    "validityUnder6": "Válido < 6 meses",
    "validityAfter6": "Válido > 6 meses",
    "label": "fecha de caducidad del certificado"
  },
  "validityInMonth": "La validez seleccionada es en meses",
  "range": "Gama",
  "creationDate": {
    "label": "Fecha de incorporación",
    "formatter": {
      "input": "DD/MM/AAAA",
      "tag": "DD/MM/AAAA"
    },
    "periodSeparator": "al",
    "placeholder": "Seleccione un período"
  },
  "selectCreationDate": "Seleccionar la fecha",
  "date": {
    "to": "al",
    "startPlaceholder": "Fecha de inicio",
    "endPlaceholder": "Fecha de finalización",
    "formatter": {
      "tag": "DD/MM/YYYY"
    },
    "periodSeparator": "al",
    "period": {
      "placeholder": "Seleccione un período",
      "separator": "al"
    }
  },
  "resetFilter": "Eliminar el filtro",
  "validateFilter": "Validar el filtro",
  "searchDevice": "Buscar equipos",
  "sector": "Red",
  "searchOperations": "Buscar operaciones",
  "searchByLastNameOrFirstName": "Buscar por apellido o nombre",
  "search": "Buscar",
  "status": "Estado",
  "firmware": {
    "range": "Gama"
  },
  "connectivityState": {
    "active": "Conectado",
    "inactive": "Inactivo"
  }
}
